import { useCallback, useState } from 'react'

export const usePagination = () => {
  const [cursor, setCursor] = useState<string | undefined>(undefined)
  const [prevCursors, setPrevCursors] = useState<(string | undefined)[]>([])

  const onNextPage = useCallback(
    (nextCursor: string | undefined) => {
      setPrevCursors(prev => [...prev, cursor])
      setCursor(nextCursor)
    },
    [cursor, prevCursors],
  )

  const onPreviousPage = useCallback(() => {
    const newPrevCursors = [...prevCursors]
    const previousCursor = newPrevCursors.pop()
    setPrevCursors(newPrevCursors)
    setCursor(previousCursor ?? undefined)
  }, [cursor, prevCursors])

  const goToLastPage = useCallback(
    (lastCursor: string) => {
      setPrevCursors(prevCursor => [...prevCursor, cursor])
      setCursor(lastCursor)
    },
    [cursor],
  )

  const goToFirstPage = useCallback(() => {
    setPrevCursors([])
    setCursor(undefined)
  }, [])

  return {
    cursor,
    onNextPage,
    onPreviousPage,
    goToFirstPage,
    goToLastPage,
    page: prevCursors.length + 1,
    isPreviousAvailable: prevCursors.length > 0,
    isNextAvailable: !!cursor,
  }
}
